import { type ReactNode, createContext, useContext, useMemo } from 'react';

export interface SearchContextValue {
  selectedId?: string;
  setSelectedId: (id: string | undefined) => void;
}

export const SearchContext = createContext<SearchContextValue>({
  setSelectedId: () => {},
});

export const useSearch = () => useContext(SearchContext);

interface WrapperProps {
  children: ReactNode;
  selectedId?: string;
  setSelectedId: (id: string | undefined) => void;
}

export const SearchContextWrapper = ({
  children,
  selectedId,
  setSelectedId,
}: WrapperProps) => {
  const value = useMemo(
    () => ({
      selectedId,
      setSelectedId,
    }),
    [selectedId, setSelectedId],
  );

  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  );
};
